<template>
    <div class="board-mid-article">
        <SoundSpaceDice
            is-loop
            v-model="numsEnable"
            :volume="soundVolume"
            name="spaceDiceNum"
        />
        <div class="article-parts left-parts">
            <img src="@/assets/imgs/casino/diceSpace/leftPart.png" width="106" height="46" alt="" />
            <!-- <div class="aside-nums">
                <p>0000</p>
                <p>1111</p>
                <p>2222</p>
                <p>3333</p>
            </div> -->
            <div class="aside-points" v-if="numsEnable">
                <p :style="{ opacity: handleGetOpacity(0) }"></p>
                <p :style="{ opacity: handleGetOpacity(1) }"></p>
                <p :style="{ opacity: handleGetOpacity(2) }"></p>
                <p :style="{ opacity: handleGetOpacity(5) }"></p>
                <p :style="{ opacity: handleGetOpacity(4) }"></p>
                <p :style="{ opacity: handleGetOpacity(3) }"></p>
            </div>
        </div>
        <div class="article-parts right-parts">
            <img src="@/assets/imgs/casino/diceSpace/leftPart.png" width="106" height="46" alt="" />
            <!-- <div class="aside-nums">
                <p>4444</p>
                <p>5555</p>
                <p>6666</p>
                <p>7777</p>
            </div> -->
            <div class="aside-points" v-if="numsEnable">
                <p :style="{ opacity: handleGetOpacity(0) }"></p>
                <p :style="{ opacity: handleGetOpacity(1) }"></p>
                <p :style="{ opacity: handleGetOpacity(2) }"></p>
                <p :style="{ opacity: handleGetOpacity(5) }"></p>
                <p :style="{ opacity: handleGetOpacity(4) }"></p>
                <p :style="{ opacity: handleGetOpacity(3) }"></p>
            </div>
        </div>
        <IconSvgUse
            use="boardmid-cont-top-side"
            class="boardmid-cont-top-side"
            width="18"
            height="18"
        />
        <IconSvgUse
            use="boardmid-cont-top-side"
            class="boardmid-cont-top-side"
            width="18"
            height="18"
        />
        <div :class="animateClass" class="control-container">
            <div class="rang-number">
                <h5 v-if="(!is_in && minModelValue !== config.min) || is_in" class="left-number">
                    {{ is_in ? minModelValue : config.min }}
                    <span>≤</span>
                </h5>
                <h5 v-if="!is_in && maxModelValue !== config.max" class="left-number">
                    {{ is_in ? maxModelValue : maxModelValue }}
                    <span>≤</span>
                </h5>
            </div>
            <ChoseNumber
                v-if="isInputNumber"
                :maxModelValue="maxModelValue"
                :minModelValue="minModelValue"
                :is_in="is_in"
                @click.self="onSwitch"
                :config="config"
                @update:maxValue="emit('update:maxValue', $event)"
                @update:minValue="emit('update:minValue', $event)"
                @isInputNumber="onSwitch"
            />
            <div v-else class="number-content" @click="onSwitch">
                <div
                    class="number-wrap"
                    :class="[isGreen ? 'text-[#24e34d]' : 'text-[#F82E59FF]']"
                    style="
                        font-family: electronicFont;
                        clip-path: polygon(7% 0, 100% 0, 100% 100%, 0 100%, 0 21%);
                    "
                >
                    {{ animatedNumber }} 
                </div>
            </div>
            <div class="rang-number">
                <h5 v-if="!is_in && minModelValue !== config.min" class="right-number">
                    <span>≤</span>
                    {{ is_in ? minModelValue : minModelValue }}
                </h5>
                <h5 v-if="(!is_in && maxModelValue !== config.max) || is_in" class="right-number">
                    <span>≤</span>
                    {{ is_in ? maxModelValue : config.max }}
                </h5>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { startCountingAnimate } from '~/utils/animate';
import ChoseNumber from './ChoseNumber.vue';
import useSettingsStore from '~/stores/settings';
import { useAutoOptionStore } from '~/stores/cansino/autoOption';
const autoOption = useAutoOptionStore();
const { isAutoBetting} = storeToRefs(autoOption);
const settingStore = useSettingsStore();
const isInputNumber = ref(false);
const numsEnable = ref(false);
const animateClass = ref('');
const activePoints = ref(0);
const activePoints1 = ref(0);
const activePoints2 = ref(0);
const timer = ref(null);
const props = defineProps({
    betAmount: {
        type: Number,
    },
    config: {
        type: Object,
    },
    maxModelValue: {
        type: Number,
        required: true,
    },
    minModelValue: {
        type: Number,
        required: true,
    },
    is_in: {
        type: Boolean,
        required: true,
    },
    fastTime: {
        type: Number,
        required: true,
    },
    sound: {
        type: Boolean,
        required: true,
    },
    soundVolume: {
        type: Number,
        required: true,
    },
});
const animatedNumber = ref(0);
animatedNumber.value = props.betAmount;
const isGreen = computed(() => {
    if (props.is_in) {
        const isBetAmountInRange =
            props.betAmount >= props.minModelValue && props.betAmount <= props.maxModelValue;
        return isBetAmountInRange;
    } else {
        const isBetAmoutOutRange =
            props.betAmount < props.minModelValue || props.betAmount > props.maxModelValue;
        return isBetAmoutOutRange;
    }
});

const emit = defineEmits(['update:maxValue', 'update:minValue']);

const onSwitch = () => {
    // 模式等于自动 & 开始时不允许切换
    if(settingStore.game.spacedice.auto.default && isAutoBetting.value){
        console.log('自动不需要切换')
        return
    }
    isInputNumber.value = !isInputNumber.value;
    animateClass.value = isInputNumber.value ? 'animation--bottom' : 'animation--top';
    setTimeout(() => {
        animateClass.value = '';
    }, 500);
};

/**
 * 计时器，每600毫秒执行handlePoints
 */
const handleInterval = () => {
    timer.value = setInterval(handlePoints, 600);
};
/**
 * 改变activePoints的值
 */
const handlePoints = () => {
    activePoints2.value = activePoints1.value;
    activePoints1.value = activePoints.value;
    ++activePoints.value > 5 && (activePoints.value = 0);
};
/**
 * 根据points获取对应的opacity
 * @param points { number } 当前key
 */
const handleGetOpacity = (points: number) => {
    return points === activePoints.value
        ? '.4'
        : activePoints1.value === points
        ? '.3'
        : activePoints2.value === points
        ? '.2'
        : '.1';
};
watch(
    () => props.betAmount,
    (newValue, oldValue) => {
        if (props.sound) {
            numsEnable.value = true;
        }

        startCountingAnimate(
            oldValue,
            newValue,
            props.fastTime,
            animatedNumber,
            () => (numsEnable.value = false),
        );
    },
);
onMounted(() => {
    handleInterval();
});
onBeforeUnmount(() => {
    clearInterval(timer.value);
});

const fnStopInputing = ()=>{
    isInputNumber.value = false;
};

defineExpose({
    fnStopInputing,
});

</script>

<style lang="scss" scoped>
.board-mid-article {
    background: transparent;
    border: 1px solid #708aa9;
    border-radius: 21px 21px 0 0;
    position: relative;
    width: 100%;
    .article-parts {
        left: 0;
        position: absolute;
        top: 52%;
        transform: translate(-100%, -50%);
        @media (max-width: 700px) {
            display: none;
        }
        &:nth-child(2) {
            left: auto;
            right: 0;
            transform: translate(100%, -50%);
            img {
                transform: scaleX(-1);
            }
        }
        .aside-nums {
            display: grid;
            gap: 1px;
            grid-template-columns: repeat(auto-fit, minmax(20px, 1fr));
            height: 19px;
            position: absolute;
            width: 43px;
            p {
                color: #fff3;
                font-size: 7px;
                font-weight: 500;
                line-height: 9px;
                margin: 0;
            }
        }
    }
    .aside-points {
        display: grid;
        gap: 1px;
        grid-template-columns: repeat(auto-fit, minmax(5px, 1fr));
        height: 11px;
        position: absolute;
        transform: scale(1.1);
        width: 18px;
        p {
            background: #fff;
            border-radius: 50%;
            height: 2px;
            margin: 0;
            width: 2px;
            // opacity: .1
        }
    }
    .left-parts {
        .aside-nums {
            left: 0;
            top: 57%;
        }
        .aside-points {
            left: 52%;
            top: 35%;
        }
    }
    .right-parts {
        .aside-nums {
            left: 62%;
            top: 57%;
        }
        .aside-points {
            left: 35%;
            top: 35%;
        }
    }
    .boardmid-cont-top-side {
        left: 0;
        position: absolute;
        top: 0;
        transform: scale(1.15);
        z-index: 1;
        &:nth-of-type(2) {
            left: auto;
            right: 0;
            transform: scaleX(-1.15) scaleY(1.15);
        }
    }
}

.control-container {
    height: 100px;
    width: 100%;
    align-items: center;
    display: flex;
    justify-content: space-between;
    .number-content {
        background-image: url('@/assets/svg/CounterBg.svg');
        background-size: 100%;
        cursor: pointer;
        width: 50%;
        background-repeat: no-repeat;
        @media (max-width: 550px) {
            background-image: url('@/assets/svg/CounterBgMob.svg');
        }
    }
}

.animation--top {
    animation: shuffle 0.5s ease;
    overflow: hidden;
}

.animation--bottom {
    animation: shuffleRevert 0.5s ease;
    overflow: hidden;
}
.rang-number {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding-top: 12px;
}

.left-number,
.right-number {
    color: #fff;
    flex: 1;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: -0.02em;
    line-height: 20px;
    margin-bottom: 0;
    text-align: center;
    &:nth-child(2) {
        margin-top: 16px;
    }
    span {
        color: #889bb2;
        font-size: 18px;
        font-weight: 500;
    }
}

.number-wrap {
    font-size: 4rem;
    text-align: center;
    line-height: 1;
    width: 100%;
}

@keyframes shuffle {
    0% {
        opacity: 0;
        transform: translateY(-50px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes shuffleRevert {
    0% {
        opacity: 0;
        transform: translateY(50px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.line-100 {
    line-height: 100px;
}
</style>
